import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

export const theme = createTheme({
  palette: {
    primary: {
      main: red[500],
    },
  },
});

export { globalStyles } from './GlobalStyles';
